<template>
    <div class="root">
        <div class="logo-header">
            <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2026<br>Sanitäts- und
                Rettungsdienst
            </span>
            <img src="../assets/logo-drk.svg" class="logo-image"/>
        </div>
        <el-card width="250px" class="loginbox">
            <template #header>
                <h3>Login</h3>
            </template>
            <el-input type="text" placeholder="Username" v-model="username"/>
            <el-input type="password" placeholder="Password" v-model="password" show-password/>
            <el-button type="primary" @click="login">Login</el-button>
        </el-card>
        <div class="hlogo">
            <img src="../assets/2026_hurricane.webp" width="650">
        </div>
    </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import Password from "@/components/password.vue";
import {ref} from "vue";

export default {
    name: "home",
    components: {Password},
    data() {
        return {
            username: ref(''),
            password: ref(''),
            msg: ref(''),
            centerDialogVisible: ref(false)
        };
    },
    methods: {
        async login() {
            try {
                const credentials = {
                    email: this.username,
                    password: this.password
                };
                const response = await AuthService.login(credentials);
                this.msg = response.msg;
                const token = response.data.token;
                const user = response.data.name;
                const unit = response.data.unit;
                const role = response.data.role;
                const email = response.data.email;
                this.$store.dispatch('login', {token, user, unit, role, email});
                this.$router.push('/unitdashboard');
            } catch (error) {
                this.msg = error.response.data.msg;
            }
        }
    }
}
</script>

<style scoped>
.root {
    width: 1024px;
    position: absolute;
    top: 450px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}

.hlogo {
    margin-top: 50px;
}

.loginbox {
    width: 250px;
    margin-top: 50px;
    display: inline-block;
}

</style>
